var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{staticClass:"btn-wrapper-add-link create-link-btn",attrs:{"size":"small"},on:{"click":_vm.addId}},[(_vm.icon)?_c('a-icon',{attrs:{"type":_vm.icon}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }